import { Route, Routes } from "react-router-dom";
import OrdersRoutes from "./Orders";
import EnrollmentProcessingRoutes from "./EnrollmentProcessing";
import OrganizationsRoutes from "./Organizations";
import CohortsRoutes from "./Cohorts";
import AutomationsRoutes from "./Automations";

export default function ProgramManagementRouter() {
  return (
    <Routes>
      <Route path="/orders/*" element={<OrdersRoutes />} />
      <Route
        path="/enrollment-processing/*"
        element={<EnrollmentProcessingRoutes />}
      />
      <Route path="/organizations/*" element={<OrganizationsRoutes />} />
      <Route path="/cohorts/*" element={<CohortsRoutes />} />
      <Route path="/automations/*" element={<AutomationsRoutes />} />
    </Routes>
  );
}
